export const nodeNames = {
  centerLine: 'centerLine', // 여러개 센터라인 결국 fai용
  singleCenterLine: 'centerLine.0', //단일 센터라인
  stenosis: 'stenosis',
  node: 'node',
  nodeAVC: 'node.aortic',
  nodeAnnulus: 'node.annulus',
  nodeSinotubular: 'node.sinotubular',
  nodeSihus: 'node.sihus',
  measurement: 'measurement',
} as const;

export type loadKeys = (typeof nodeNames)[keyof typeof nodeNames];

export const volumeNames = {
  base: 'volume',
  heartCut: 'volumeHeartCut',
  MIP: 'volumeMIP',
  calcium: 'volumeCalcium',
} as const;

export type volumeKeys = (typeof volumeNames)[keyof typeof volumeNames];

export const FFRNames = {
  aorta:'FFR_aorta',
  main_rca: 'FFR_main_rca',
  main_lca: 'FFR_main_lca',
  cap_rca: 'FFR_cap_rca',
  cap_lca: 'FFR_cap_lca',
  centerline: 'FFR_centerline',
} as const;

export function getFFRArteryTypes() {
  return ['rcaFFR', 'lcxFFR', 'ladFFR'] as const;
}

export const FFR_OPACITY = {
  DEFAULT: 0.2,
  FULL: 1.0,
  cap:0.2,
};

export const axesNames = {
  Axial: 'Axial',
  Coronal: 'Coronal',
  Sagittal: 'Sagittal',
} as const;


export const FFR_ARTERY_TYPE = {
  RCA: 0,
  LCX: 1,
  LAD: 2,
};

export const FFR_ARTERY_NAME = {
  [FFR_ARTERY_TYPE.RCA]: 'rca',
  [FFR_ARTERY_TYPE.LCX]: 'lcx',
  [FFR_ARTERY_TYPE.LAD]: 'lad',
} as const;

export type Bounds = [number, number, number, number, number, number];

export function getDilateVolumeIndices(volumeName: volumeKeys){
  return false;
  if(volumeName === volumeNames.MIP){
    return false;
  }
  return true;
}
